import React from 'react';
import { FiPlus, FiTrash2, FiClock, FiMail } from 'react-icons/fi';

const formatSavedAt = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const SavedSmtpList = ({ configs, onConnect, onDelete, onAddNew }) => (
  <div className="ec-smtp-saved-panel">
    <div className="ec-smtp-saved-header">
      <div>
        <div className="ec-smtp-saved-title">Saved SMTP Configurations</div>
        <div className="ec-smtp-saved-count">{configs.length} configuration{configs.length !== 1 ? 's' : ''} saved</div>
      </div>
      <button className="ec-smtp-add-new-btn" onClick={onAddNew}>
        <FiPlus size={13} /> Add New
      </button>
    </div>

    <div className="ec-smtp-saved-list">
      {configs.map((config) => (
        <div key={config.id} className="ec-smtp-saved-item">
          <div className="ec-smtp-saved-item-left">
            <div className="ec-smtp-saved-avatar">
              <FiMail size={16} />
            </div>
            <div className="ec-smtp-saved-info">
              <div className="ec-smtp-saved-name">{config.name}</div>
              <div className="ec-smtp-saved-meta">
                {config.host} &nbsp;·&nbsp; {config.port}
              </div>
              <div className="ec-smtp-saved-time">
                <FiClock size={11} />
                Saved {formatSavedAt(config.savedAt)}
              </div>
            </div>
          </div>

          <div className="ec-smtp-saved-item-right">
            <button
              className="ec-smtp-delete-btn"
              onClick={() => onDelete(config.id)}
              title="Delete"
            >
              <FiTrash2 size={14} />
            </button>
            <button
              className="ec-smtp-connect-btn"
              onClick={() => onConnect(config)}
            >
              Connect &rsaquo;
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SavedSmtpList;
